import React, { Component } from "react";
import Slider from "react-slick";
import './style.css'

export default class SimpleSlider extends Component {

    state={
        dataImage : this.props.dataImage
    }

    renderImage=()=>{
        return this.state.dataImage.map((val)=>{
            return (
                <div className="activities-content">
                    <img src={val} alt=''/>
                </div>
            )
        })
    }
    

    render() {
        const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: true
    };

    return (
      <div className='slider-container'>
        <Slider {...settings}>
          {this.renderImage()}
        </Slider>
      </div>
    );
  }
}